import React, { useRef, useState, useEffect } from 'react';
import './cardSlider.css';
import { Link } from 'react-router-dom';
import { cards } from '../../../../json/sections/about/cards';
import { FaArrowRight } from "react-icons/fa6";

const CardSlider = () => {
    const sliderRef = useRef(null);
    const [visibleCards, setVisibleCards] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const updateVisibleCards = () => {
            const width = window.innerWidth;
            if (width >= 992) setVisibleCards(4);       // Desktop
            else if (width >= 768) setVisibleCards(3);  // Tablet
            else setVisibleCards(1);                    // Mobile
        };
        updateVisibleCards();
        window.addEventListener('resize', updateVisibleCards);
        return () => window.removeEventListener('resize', updateVisibleCards);
    }, []);

    const handleScroll = (dir) => {
        const cardWidth = sliderRef.current.querySelector('.card-custom')?.offsetWidth || 0;
        const gap = 16;
        const fullCardWidth = cardWidth + gap;

        const maxIndex = cards.length - visibleCards;
        const newIndex = dir === 'left' ? Math.max(currentIndex - 1, 0) : Math.min(currentIndex + 1, maxIndex);

        const scrollLeft = fullCardWidth * newIndex;

        sliderRef.current.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
        });

        setCurrentIndex(newIndex);
    };

    return (
        <div className='container'>
            <div className='row'>
                <div className="slider-container">
                    <button
                        className="slider-btn left"
                        onClick={() => handleScroll('left')}
                        disabled={currentIndex === 0}
                    >
                        &lt;
                    </button>
                    <div className="slider" ref={sliderRef}>
                        {cards.map((card, i) => (
                            <div className="card-custom" key={i}>
                                {i % 2 === 0 ? (
                                    <>
                                        <div className='img-card-service' style={{
                                            backgroundImage: `url(${card.img})`,
                                            width: "100%",
                                            minHeight: "320px",
                                            backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "cover"
                                        }}></div>
                                        <div className="card-body">
                                            <h3 dangerouslySetInnerHTML={{ __html: card.title }}></h3>
                                            <p className='casper-normal'>{card.text}</p>
                                            <Link to={`/services/${card.ref}`} className="btn btn-primary">
                                                LEARN MORE <FaArrowRight className='card-arrow' />
                                            </Link>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="card-body">
                                            <h3 dangerouslySetInnerHTML={{ __html: card.title }}></h3>
                                            <p className='casper-normal'>{card.text}</p>
                                            <Link to={`/services/${card.ref}`} className="btn btn-primary">
                                                LEARN MORE <FaArrowRight className='card-arrow' />
                                            </Link>
                                        </div>
                                        <div className='img-card-service' style={{
                                            backgroundImage: `url(${card.img})`,
                                            width: "100%",
                                            minHeight: "320px",
                                            backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "cover"
                                        }}></div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                    <button
                        className="slider-btn right"
                        onClick={() => handleScroll('right')}
                        disabled={currentIndex >= cards.length - visibleCards}
                    >
                        &gt;
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CardSlider;
